import {createFileRoute, redirect} from '@tanstack/react-router'

// The standalone FAQ page was retired — the same FAQ content now lives on the
// homepage. The /faq URL is still indexed, so permanently (301) redirect it to /
// to consolidate ranking signals there rather than leaving a dead/thin page.
export const Route = createFileRoute('/faq')({
    beforeLoad: () => {
        throw redirect({to: '/', statusCode: 301})
    },
})
